<div class="ziti-page-container ziti-posture-checks-container lt-skin-page">
  <lib-list-table-header
    [title]="title"
    subtitle="Verify the state of identities before granting access"
    createLabel="Create Posture Check"
    infoText="Posture checks verify attributes of an identity, such as its OS or MFA status, before access is granted."
    [tabs]="tabs"
    [showAdd]="!itemsSelected"
    [blockCreate]="headerBlockCreate"
    [blockDelete]="headerBlockDelete"
    (actionClicked)="headerActionClicked($event)"
  >
    <span header-icon class="icon-posturechecks" aria-hidden="true"></span>
  </lib-list-table-header>
  <ng-content select="[slot=list-page-subheader]"></ng-content>
  <lib-list-table class="lt-skin" [tableId]="tableId" [initialPageSize]="initialPageSize"
    [noItemsReadonly]="headerBlockCreate"
    [accessDenied]="headerBlockRead"
    [rowData]="rowData"
    [isLoading]="isLoading"
    [columns]="columnDefs"
    (actionRequested)="tableAction($event)"
    [startCount]="startCount"
    [endCount]="endCount"
    [totalCount]="totalCount"
    [filterApplied]="filterApplied"
    [menuItems]="svc.menuItems"
    [headerActions]="svc.tableHeaderActions"
    [noItemsImage]="'No_Clients'"
    (tableReady)="tableReady($event)"
    >
  </lib-list-table>
</div>
@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
